import { FC } from 'react';
import styled from 'styled-components';

export interface IProps extends IntrinsicProps {
  /** Text color. Defaults to theme.vars.newColor.darkGS1 */
  color?: string;
  /** Bold styling. Optional */
  bold?: boolean;
  /** Font size. Optional */
  fontSize?: string;
  htmlTag?: ElementType;
  /** Font variant */
  variant?: 'body1' | 'body2' | 'headingH1';
}
type ElementType = 'span' | 'div';
const ParagraphElement = styled.p<IProps>`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
  line-height: ${({ fontSize }) => (fontSize ? '1.5' : '24px')};
  font-weight: ${props => (props.bold ? '600' : '500')};
  color: ${props => (props.color ? props.color : props.theme.vars.newColor.darkGS1)};
  margin: 0;
  padding: 0;
  ${({ theme, variant }) => (variant ? `font: ${theme.designToken[variant]};` : undefined)};

  & + & {
    margin-top: 10px;
  }
`;

export const Paragraph: FC<IProps> = ({ color, bold, htmlTag, fontSize, children, ...rest }) => {
  return (
    <ParagraphElement color={color} bold={bold} as={htmlTag} data-testid="Paragraph" {...rest}>
      {children}
    </ParagraphElement>
  );
};
